import {createAsyncThunk} from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../utils/axios/requestInfo";
import { api } from "../../../../resources/api";

export const fetchDeleteUser = createAsyncThunk<void>(
  "user/deleteUser",
  async () => {
    try {
      await axiosInstance.delete(api.profile.settings.getProfile.DELETE_USER);
    } catch (error) {
      throw error;
    }
  }
);

